module.exports = __webpack_public_path__ + "img/DS-M-6.c0d77cb1.svg";